import utils from 'hey-utils';
import manba from 'manba';
import Humanize from 'humanize-plus';

const rclass = /[\t\r\n\f]/g;

export default utils.extend({}, utils, {
  toSelectEmpresa(resp) {
    if ('ok' in resp) {
      const { data } = resp;
      !resp.ok
        ? resp = []
        : resp = data.map(empresa => empresa);
    }
    return (resp.data || resp || []).map((empresa, idx) => {
      return {
        key: empresa._id,
        title: empresa.nomeFantasia
      };
    });
  },
  arredondarComCasasDecimais(number) {
    return Math.round((number * 100)) / 100;
  },
  debounce(func, wait) {
    let timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(func, wait);
    };
  },
  toSelect(id, title, resp) { // caso precise alterar estrutura do objeto
    if (!resp) resp = [];
    return (resp.data || resp || []).map((item, idx) => {
      return {
        key: item[id],
        title: item[title]
      };
    });
  },
  getClass(elem) {
    return (elem.getAttribute && elem.getAttribute('class')) || '';
  },
  hasClass(elem, selector) {
    let className;
    className = ` ${selector} `;
    if (elem.nodeType === 1 && (` ${this.getClass(elem)} `)
      .replace(rclass, ' ')
      .indexOf(className) > -1) {
      return true;
    }

    return false;
  },
  getPermission(...actions) {
    const storage = localStorage.getItem('v360.permissao');
    if (storage !== 'undefined' && !this.isNullOrEmpty(storage)) {
      return actions.flat().some(item => JSON.parse(storage).includes(item));
    } else {
      return false;
    }
  },
  getPermissionNames(...actions) {
    const storage = localStorage.getItem('v360.permissao');

    try {
      return actions.flat().filter(item => JSON.parse(storage).includes(item));
    } catch (e) {
      return [];
    }
  },
  handleErrorRequest(response) {
    if (response) {
      if (response.status === 403) {
        return 'Permissão necessária';
      } else {
        return response.status !== 200 ? 'Ocorreu algum erro em sua pesquisa.' : '';
      }
    } else {
      return 'Ocorreu algum erro em sua pesquisa.';
    }
  },
  splitDate(dateArray) {
    if (Array.isArray(dateArray)) {
      const array = typeof dateArray[0] !== 'string' ? this.convertDateToISOString(dateArray) : dateArray;
      return array.map(d => d.split('T')[0]);
    } else {
      return dateArray.split('T')[0];
    }
  },
  isEmptyString: function (val) {
    const regex = new RegExp('\\S', 'g');
    return !regex.test(val);
  },
  isNullOrEmpty: function (value) { // Verifica se valor é null | vazio | undefined | [] | {}
    if (Array.isArray(value)) {
      return !value.length;
    }
    if (Object.prototype.toString.call(value) == '[object Object]') {
      return !Object.entries(value).length;
    }

    return !!(value == undefined || value == null || value == '');
  },
  toInt(num, showNull) {
    return num ? Number(num).toLocaleString('pt-BR', { minimumFractionDigits: 0 }) : (showNull ? '0' : '');
  },
  toMoney(num, digits, showNull) { // FORMATA REAL
    // return num ? Number(num).toLocaleString('pt-BR', { minimumFractionDigits: digits || 2, style: 'currency', currency: 'BRL' }) : (showNull ? '' : 'R$ 0,00');
    return 'R$ ' + Humanize.compactInteger(num, 1);
  },
  toMoney2(num, digits, showNull) { // FORMATA REAL
    return num ? Number(num).toLocaleString('pt-BR', { minimumFractionDigits: digits || 2, style: 'currency', currency: 'BRL' }) : (showNull ? '' : 'R$ 0,00');
  },
  toPercent(num, digits, showNull) {
    return num ? Number(num * 100).toLocaleString('pt-BR', { minimumFractionDigits: digits !== undefined ? digits : 2, maximumFractionDigits: digits !== undefined ? digits : 2 }) + '%' : (showNull ? '0,00 %' : '');
  },
  removeElementFromArray(array, objectId) {
    const idx = array.findIndex(x => x._id === objectId);
    if (idx !== -1) {
      array.splice(idx, 1);
    }
  },
  formatDateTime: (dateTime, format = 'DD/MM/YYYY hh:mm') => moment(dateTime).utc(false).format(format),
  formatDateTimeWithUtc: (dateTime, format = 'DD/MM/YYYY hh:mm') => moment(dateTime).utc(true).format(format),
  toCSharpDate: (date, format = 'DD/MM/YYYY') => manba(date, format).format('YYYY-MM-DD'),
  toSimOuNao: (value) => value ? 'Sim' : 'Não',

  getIdsTable(table) {
    return table.getSelection().map(x => x._id);
  },
  createNotification(title, body, icon) {
    title = title || 'F360 - Performance';
    const options = {
      icon: icon || 'https://www.financas360.com.br/favicon.ico',
      body: body || ''
    };

    if (!('Notification' in window)) {
      return null;
    } else if (Notification.permission === 'granted') {
      try {
        return new Notification(title, options);
      } catch (e) {
        if (e.name == 'TypeError') {
          return false;
        }
      }
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(function (permission) {
        if (permission === 'granted') {
          try {
            return new Notification(title, options);
          } catch (e) {
            if (e.name == 'TypeError') {
              return false;
            }
          }
        }
      });
    }
    return null;
  },
  convertDateToISOString(value) {
    if (value === undefined) return;

    if (Array.isArray(value)) {
      let dates = this.removeElementsBySpecifiedValue(value, undefined);
      return dates.map(v => typeof v.toISOString === 'function' ? v.toISOString() : v);
    } else {
      return typeof value.toISOString === 'function' ? value.toISOString() : value;
    }
  },
  symmetricDifference(a, b) {
    const sA = new Set(a);
    const sB = new Set(b);
    return [...a.filter(x => !sB.has(x)), ...b.filter(x => !sA.has(x))];
  },
  flatAll(array) {
    return array.flat(Infinity);
  },
  removeElementsBySpecifiedValue(array, ...args) {
    return array.filter(v => !args.includes(v));
  },
  getFirstDayInMonth(year = false, month = false) {
    return moment(`${year}-${month + 1}-1`, 'YYYY/MM/DD').startOf('month').toDate();
  },
  getLastDayInMonth(year = false, month = false) {
    return moment(`${year}-${month + 1}-1`, 'YYYY/MM/DD').endOf('month').toDate();
  },
  getUniqueDayInMonth(yearParams = false, monthParams = false, day) {
    let year = yearParams;
    let month = monthParams;
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      if (date.getDay() === day) {
        days.push(new Date(date));
      }
      date.setDate(date.getDate() + 1);
    }
    return days;
  },
  arrayToObject(array) {
    return array.reduce(function (result, item) {
      var key = Object.keys(item)[0];
      result[key] = item[key];
      return result;
    }, {});
  },
  getAllDaysInMonth(yearParams = false, monthParams = false) {
    let year = yearParams;
    let month = monthParams;

    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));

      date.setDate(date.getDate() + 1);
    }
    return days;
  },
  getDay(year = false, month = false, day) {
    return moment(`${year}-${month + 1}-${day}`).toDate();
  },
  notify(body, onClick, title, icon) {
    const notification = this.createNotification(title, body, icon);
    if (typeof onClick === 'function') {
      notification.onclick = onClick;
    }
    return notification;
  },
  formError(form, errors) {
    const messages = form.messages;
    if (!(errors instanceof Array)) {
      return;
    }
    errors.forEach(error => {
      const field = error.field.toLowerCase();
      messages[field].message = error.message;
      messages[field].valid = false;
      messages[field].prop = '';
    });
  },
  DatesIsEquals(date1, date2) {
    return this.convertDateToISOString(date1) === this.convertDateToISOString(date2);
  },
  deepClone(obj) {
    if (obj === null) return null;
    let clone = Object.assign({}, obj);
    Object.keys(clone).forEach(
      key => (clone[key] = typeof obj[key] === 'object' ? this.deepClone(obj[key]) : obj[key])
    );
    return Array.isArray(obj) && obj.length
      ? (clone.length = obj.length) && Array.from(clone)
      : Array.isArray(obj)
        ? Array.from(obj)
        : clone;
  },
  maxWithCallback(array, callback) {
    const [max] = array.sort(callback);
    return max;
  },
  max(array) {
    const [max] = array.sort((a, b) => b - a);
    return max;
  },
  compararDataAnterior(dataBase, totalAnos) {
    const fevereiro = 1;

    const dataFormatada = moment(dataBase);

    let dataCalculada = new Date(dataBase.getFullYear() - (totalAnos || 1), dataBase.getMonth(), dataBase.getDate());

    // Verificar se o ano é bissexto, caso seja, retira um dia
    if (moment(dataFormatada).isLeapYear()) {
      if (moment(dataFormatada).month() === fevereiro) {
        dataCalculada = new Date(dataBase.getFullYear() - (totalAnos || 1), dataBase.getMonth(), dataBase.getDate() - 1);
      }
    }

    let diferencaDias = 0;
    const fatorDiaSemana = dataBase.getDay() - dataCalculada.getDay();
    if ((fatorDiaSemana < 0) && Math.abs(fatorDiaSemana) > 3) {
      diferencaDias = (7 - Math.abs(fatorDiaSemana));
    } else if ((fatorDiaSemana > 0) && Math.abs(fatorDiaSemana) > 3) {
      diferencaDias = (7 - Math.abs(fatorDiaSemana)) * -1;
    } else {
      diferencaDias = fatorDiaSemana;
    }
    return moment(new Date((diferencaDias * (1000 * 24 * 60 * 60)) + dataCalculada.getTime())).utc(false);
  },
  contarQuantidadeDeDias({ start, end }) {
    const startMoment = moment(start, 'DD/MM/YYYY');
    const endMomment = moment(end, 'DD/MM/YYYY');

    return endMomment.diff(startMoment, 'days');
  },
  contarDiasComAnoBissexto({ start, end }) {
    const startMoment = moment(start, 'DD/MM/YYYY');
    const endMomment = moment(end, 'DD/MM/YYYY');

    const days = endMomment.diff(startMoment, 'days');

    if (startMoment.isLeapYear()) {
      if (startMoment.month() === 1 || endMomment.month() === 1) {
        return days - 1;
      }
    }

    return days;
  },
  getReference: (ctx, ref) => {
    return new Promise(function (resolve) {
      var countRecursive = 0;

      function verifyReference(reference) {
        if (countRecursive === 300) {
          return;
        }

        if (!reference) {
          setTimeout(function () {
            verifyReference(ctx.$refs[ref]);
          }, 700);
          countRecursive++;
        } else {
          resolve(reference);
        }
      }
      verifyReference(ctx.$refs[ref]);
    });
  },
  paginacaoListas(data, atual, limit) {
    /*
      data  = array
      atual = number página atual
      limit = limit de itens por página
    */
    let result = [];
    let items = data;
    let pageActual = atual;
    let limitItems = limit;
    let totalPage = Math.ceil(items.length / limitItems);
    let count = (pageActual * limitItems) - limitItems;
    let delimiter = count + limitItems;

    if (pageActual <= totalPage) {
      for (let i = count; i < delimiter; i++) {
        if (items[i] != null) {
          result.push(items[i]);
        }
        count++;
      }
    }
    return result || [];
  },
  getLocalJson: (key) => JSON.parse(utils.getLocal(key)),
  getV360User: function () {
    try {
      return this.getLocalJson('v360.user') || {};
    } catch {
      return {};
    }
  },
  changeSleep: function (callback, time) {
    setTimeout(callback, time || 0);
  },
  isEmptyWord(word) {
    return !/\S/.test(word);
  },
  trackingF360(vue, eventName, eventCategory) {
    if (!vue || !vue.$gtag) return;
    let user = JSON.parse(localStorage.getItem('v360.user')) || {};
    let permissao = JSON.parse(localStorage.getItem('v360.permissao')) || null;
    const isAdmin = permissao
      ? permissao.find(p => p === 'ListarRegras')
      : false;

    let userInfos;
    if (user.accessToken) {
      const info = this.parseJwt(user.accessToken);
      userInfos = info;
    }
    const getMarcas = () => {
      if (user.marcas && user.marcas.length) {
        const marcasString = user.marcas.reduce((acc, m, i) => {
          acc = `${acc}${i ? ',' : ''}${m.description}`;
          return acc;
        }, '');
        return marcasString;
      }
      return '';
    };
    const marcas = getMarcas();
    const getQtdEmpresas = () => {
      if (!userInfos) return 0;
      const qtd = userInfos['user.empresa'];
      if (qtd && qtd.length) {
        return qtd.split(',').length;
      }
      return 0;
    };
    const qtdEMpresas = getQtdEmpresas();
    const metaData = {
      'event_category': eventCategory || 'Trackingf360',
      'usuario_nome': user.nome || '',
      'usuario_email': user.email || '',
      'usuario_id': userInfos['user.id'] || '',
      'grupo_nome': user.cliente || '',
      'grupo_codigo': '',
      'grupo_id': userInfos['user.cliente'] || '',
      'grupo_tipo_perfil': isAdmin ? 'Administrador' : 'Usuário comum',
      'grupo_marcas': marcas,
      'grupo_qtd_empresas': qtdEMpresas,
      'usuario_adm': !!isAdmin
    };
    this.sendGtag(vue, eventName, metaData);
  },
  parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  },
  sendGtag(vue, eventName, obj) {
    vue.$gtag.event(eventName, obj);
  }
});
